<template>
  <div id="car">
    <img-box
      class="showCar"
      :key="imgUrl + pageData.color"
      :src="imgUrl"
      :HWProportion="String((368 / 580) * 100) + '%'"
      imgWidth="100%"
    >
      <template slot="child">
        <div
          class="touchRef"
          v-if="isShow"
          @mousedown="moveCarFun($event)"
          @mousemove="moveCarFun($event)"
          @mouseup="moveCarFun($event)"
        />
        <iframe
          :src="pageData.displayDetail"
          :key="pageData.displayDetail"
          class="touchRef bg"
          scrolling="no"
          frameborder="no"
          width="100%"
          height="100%"
          v-else
        />
      </template>
    </img-box>

    <div class="carBox">
      <div class="carBtnBox">
        <img-box :src="logo" HWProportion="100%" imgWidth="60px" />
        <div :class="['carBtn', isShow ? 'active' : '']" @click="isShow = true">全景外观</div>
        <div :class="['carBtn', isShow ? '' : 'active']" v-show="iframeUrlList.length > 0" @click="isShow = false">
          全景内饰
        </div>
      </div>
      <div class="carShowText">
        <div class="text">变化车色：{{ pageData.color }}</div>
        <ul class="colorList">
          <li
            v-for="(colorItem, i) in colorList"
            :key="i"
            :class="[pageIndex == i ? 'active' : '']"
            :style="'background-color:' + colorItem.thumbnail"
            @click="changeColor(i)"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import prestrainImg from '@/components/common/prestrainImg.vue'
import logo from '@/assets/images/seller/car360.png'

export default {
  name: 'car',
  props: {
    outList: {
      type: Array
      // default: []
    },
    inUrlList: {
      type: Array
      // default: []
    }
  },
  data() {
    return {
      oldX: 0,
      imgUrl: '',
      imgIndex: -1,

      isShow: true, // 外/内
      frequency: false, // 防抖，初始关闭

      mousedownState: false,
      pageData: {},
      pageIndex: -1,
      logo: logo, // 360logo图
      imgList: this.outList,
      iframeUrlList: this.inUrlList,
      iframeUrl: '',

      colorList: [],

      touchData: {} // 滑动信息
    }
  },
  watch: {
    imgIndex(to) {
      this.changeImgUrl(to)
    },
    isShow(to) {
      this.changeColor(0)
    }
  },
  methods: {
    // 触发车型变化
    changeImgUrl(to) {
      const { rotatingImages = [] } = this.pageData
      if (rotatingImages && rotatingImages.length) {
        var imgObj = document.createElement('img')
        imgObj.src = rotatingImages[to]
        imgObj.onload = () => {
          this.imgUrl = rotatingImages[to]
        }
      }
    },
    // 改变汽车颜色
    changeColor(index) {
      if (this.isShow) {
        this.colorList = this.imgList
        this.colorList.filter((item, i) => {
          if (Number(index) === i) {
            this.pageData = item
            this.pageIndex = i
            this.imgIndex = 0
            this.changeImgUrl(0)
          }
        })
      } else {
        this.colorList = this.iframeUrlList
        this.colorList.filter((item, i) => {
          if (Number(index) === i) {
            this.pageData = item
            this.pageIndex = i
            this.imgIndex = 0
            this.changeImgUrl(0)
          }
        })
      }
    },
    // 防抖
    frequencyFun(callback) {
      if (!this.frequency) {
        callback && callback()
      }
      this.frequency = true
      setTimeout(() => {
        this.frequency = false
      }, 10)
    },
    // 滑动事件
    moveCarFun(event) {
      let touch
      /* 此处判断  pc 或 移动端 得到 event 事件 */
      if (event.touches) {
        touch = event.touches[0]
      } else {
        touch = event
      }
      const { type } = touch
      if (String(type) === 'mousedown') {
        this.mousedownState = true
      }
      if (String(type) === 'mousemove') {
        if (this.mousedownState) {
          const { clientX, target } = touch
          /*  鼠标离开车范围就去掉监听 */
          if (touch.offsetX < 30 || touch.offsetX > target.clientWidth - 30) {
            this.mousedownState = false
          }
          if (touch.offsetY < 30 || touch.offsetY > target.clientHeight - 30) {
            this.mousedownState = false
          }

          /* 向左还是向右 */
          let isLeft = this.oldX - clientX > 0
          if (Math.abs(this.oldX - clientX) > 15) {
            this.oldX = clientX
            /* ---------------------------- */
            const { rotatingImages = [] } = this.pageData

            this.frequencyFun(() => {
              if (isLeft) {
                if (this.imgIndex > 0) {
                  this.imgIndex -= 1
                } else {
                  this.imgIndex = rotatingImages.length
                }
              } else {
                if (Number(this.imgIndex) === rotatingImages.length) {
                  this.imgIndex = 0
                } else {
                  this.imgIndex += 1
                }
              }
            })
            /* ---------------------------- */
          }
        }
      }
      if (String(type) === 'mouseup') {
        this.mousedownState = false
      }
      event.preventDefault()
    }
  },
  created() {
    if (this.imgList.length) {
      this.changeColor(0)
    }
  },
  components: {
    'img-box': prestrainImg
  }
}
</script>
<style lang="scss">
#car {
  width: 100%;
  display: flex;
  flex-direction: column;
  .img {
    height: auto;
  }
  .showCar {
    position: relative;
    background-color: #e4e4e4;
    .touchRef {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    .bg {
      background-color: white;
    }
  }
  .carBox {
    /*flex: 1;*/
    display: flex;
    flex-direction: column;
    font-size: 20px;
    background: linear-gradient(180deg, rgba(121, 128, 138, 1) 0%, rgba(68, 73, 82, 1) 100%);
    .carBtnBox {
      display: flex;
      align-items: center;
      /*justify-content: space-between;*/
      padding: 0 45px;
      height: 88px;

      .prestrainImg {
        margin-right: 28px;
        .img {
          height: 0;
        }
      }
      .carBtn {
        cursor: pointer;
        width: 200px;
        height: 37px;
        line-height: 37px;
        text-align: center;
        background: linear-gradient(360deg, rgba(219, 219, 219, 1) 0%, rgba(255, 255, 255, 1) 100%);
        color: #333333;
        margin-right: 10px;
        &.active {
          position: relative;
          background: linear-gradient(180deg, rgba(41, 41, 41, 1) 0%, rgba(0, 0, 0, 1) 100%);
          color: white;
          &:before {
            position: absolute;
            bottom: -10px;
            left: 50%;
            content: '';
            width: 10px;
            height: 10px;
            background-color: #000000;
            transform: translate(-50%, -50%) rotate(-45deg);
          }
        }
      }
    }
    .carShowText {
      /*flex: 1;*/
      display: flex;
      padding: 0 45px;
      /*align-items: center;*/
      padding-bottom: 16px;
      .text {
        color: #fff;
        font-weight: 500;
        margin-right: 20px;
        height: 36px;
        line-height: 36px;
      }
      .colorList {
        flex: 1;
        li {
          display: inline-block;
          height: 36px;
          width: 36px;
          margin-right: 8px;
          border-radius: 1000%;
          background-color: #8a8d91;
          &.active {
            background: url(../../../assets/images/seller/ok.png) no-repeat center center / 50% auto;
          }
        }
      }
    }
  }
}
</style>
